import { render, staticRenderFns } from "./NotaShift.vue?vue&type=template&id=b485912a&scoped=true"
import script from "./NotaShift.vue?vue&type=script&lang=js"
export * from "./NotaShift.vue?vue&type=script&lang=js"
import style0 from "./NotaShift.vue?vue&type=style&index=0&id=b485912a&prod&scoped=true&lang=css"
import style1 from "./NotaShift.vue?vue&type=style&index=1&id=b485912a&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b485912a",
  null
  
)

export default component.exports